import { bindOn } from 'chimera/all/plugins/eventbus/events/bind'
import { getEventScope } from 'chimera/all/plugins/eventbus/scope'
import { emit } from './emit'

/**
 * User enters the post-conversion qualification flow.
 *
 * @type {string}
 */
export const postConversionEnteredEvent = 'eb_postConversionEntered'

/**
 * User completes the post-conversion qualification flow.
 *
 * @type {string}
 */
export const postConversionCompletedEvent = 'eb_postConversionCompleted'

/**
 * @param {number} matchCount
 */
export function emitPostConversionEnteredEvent(matchCount) {
  emit(postConversionEnteredEvent, {
    matchCount,
    scope: getEventScope(),
  })
}

/**
 * @param {Function} callback
 */
export function onPostConversionEnteredEvent(callback) {
  bindOn(postConversionEnteredEvent, callback)
}

/**
 * @param {number} matchCount
 */
export function emitPostConversionCompletedEvent(matchCount) {
  emit(postConversionCompletedEvent, {
    matchCount,
    scope: getEventScope(),
  })
}

/**
 * @param {Function} callback
 */
export function onPostConversionCompletedEvent(callback) {
  bindOn(postConversionCompletedEvent, callback)
}

/**
 * User submits an answer to a post-conversion qualification question.
 *
 * @type {string}
 */
export const postConversionQuestionSubmittedEvent =
  'eb_postConversionQuestionSubmitted'

/**
 * @param {string} question
 * @param {string} answer
 */
export function emitPostConversionQuestionSubmittedEvent(question, answer) {
  emit(postConversionQuestionSubmittedEvent, {
    question,
    answer,
    scope: getEventScope(),
  })
}

/**
 * @param {Function} callback
 */
export function onPostConversionQuestionSubmittedEvent(callback) {
  bindOn(postConversionQuestionSubmittedEvent, callback)
}
